import { render } from "./OrderManage.vue?vue&type=template&id=95cd678a&scoped=true"
import script from "./OrderManage.vue?vue&type=script&lang=js"
export * from "./OrderManage.vue?vue&type=script&lang=js"

import "./OrderManage.vue?vue&type=style&index=0&id=95cd678a&scoped=true&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cd678a"]])

export default __exports__